import { render, staticRenderFns } from "./UploadExcelOfPublicTender.vue?vue&type=template&id=63354d3a&scoped=true&"
import script from "./UploadExcelOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./UploadExcelOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./UploadExcelOfPublicTender.vue?vue&type=style&index=0&id=63354d3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63354d3a",
  null
  
)

export default component.exports